<!-- Floating button -->
<div class="container floatingbar-container" [ngClass]="{'open':statusButtonOpen}">
    <button type="button" class="floatingbar shadow" (click)="toggleButton()">
        <i class="fas " [ngClass]="{'fa-plus':(!statusButtonOpen) , 'fa-times':statusButtonOpen}"></i>
    </button>
    <div class="sub-button shadow" *ngFor="let item of items" (click)="clickChoiceButton(item.choice)">
        <a>
            <i class="{{item.icon}}"></i> 
        </a> 
    </div>
</div>